module.exports = __webpack_public_path__ + "img/5_89.fa546373.png";